import React from "react";
import { YMaps, Map, Placemark } from "react-yandex-maps";

export const YandexMap = ({ distributors, sortDistrubutor, coordinates }) =>  (
    <YMaps>
        <Map state={coordinates} width="auto" height="auto" className="map">
            {   distributors && 
                distributors.map(coordinates => coordinates.active_shops.map(item=> (
                    <Placemark
                        key={item.id}
                        modules={["geoObject.addon.balloon"]}
                        geometry={[item.lat, item.lng]}
                        properties={{
                            balloonContentHeader: `<strong>${coordinates.name}</strong>`,
                            balloonContent: `<span>${item.address}</span>`,
                        }}
                        options={{preset: "islands#redDotIcon"}}
                        onClick={() => sortDistrubutor(coordinates.id)}
                    />
                )))
            }
        </Map>
    </YMaps>
)


// WEBPACK FOOTER //
// ./src/components/pages/projects/distributors/YandexMap.js